import { createRatesZoneRequest } from "../../data/ratesZoneApi";
import { validateTarifaZonePayload } from "../validator/validateTarifaZonePayload";

export async function createTarifaZoneUseCase(payload) {
  const error = validateTarifaZonePayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await createRatesZoneRequest(payload);
}
